import * as React from 'react';

interface Props {
  icon: string;
  size?: string;
}

export default class Icon extends React.Component<Props> {
  static defaultProps = {
    library: 'fa',
  };

  render() {
    return (
      <span
        className={`icon${this.props.size ? ` is-${this.props.size}` : ''}`}
      >
        <i
          className={`fa fa-${this.props.icon} ${
            this.props.size === 'large' ? 'fa-2x' : ''
          }`}
        />
      </span>
    );
  }
}
